import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * Partner Capability App - iframe integration
 * 
 * Renders the partner-capability-ui app in an iframe.
 * Supports deep linking via query parameter.
 */
export function PartnerCapabilityApp() {
  const [searchParams] = useSearchParams();
  const [iframeSrc, setIframeSrc] = useState('http://localhost:3127');

  useEffect(() => {
    // Support deep linking via ?path= query parameter
    const path = searchParams.get('path');
    if (path) {
      setIframeSrc(`http://localhost:3127${path.startsWith('/') ? path : `/${path}`}`);
    } else {
      setIframeSrc('http://localhost:3127');
    }
  }, [searchParams]);

  return (
    <div className="h-screen flex flex-col">
      <div className="bg-[var(--bg-raised)] border-b px-4 py-2">
        <h1 className="text-lg font-semibold text-[var(--text-pri)]">Partner Capability System</h1>
      </div>
      <iframe
        src={iframeSrc}
        style={{
          width: '100%',
          height: 'calc(100vh - 60px)',
          border: 'none',
        }}
        title="Partner Capability System"
      />
    </div>
  );
}



